import fr from 'facet-rest';
import { RichTextDisplayField } from 'Components/UI/RichTextDisplay';

export const metaOverrideSet = fr.metaOverride()
  .override({ readonly: true }, { hidden: true })
  .nameOverride('content', {
    _hideLabel: true,
    _component: () => RichTextDisplayField,
    hidden: false,
  });
